import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import set from 'lodash/set';

import { FIELDS_MAPPER, ICON } from 'src/presentation/components/pages/chat/chatConstants';
import translationFunction from 'src/presentation/components/pages/shared/utils/translateObjectFields';

// TODO Cover with tests
export const getCleanedConfig = workingState => {
  const { INITIAL_CHAT_BUTTON_ICON_TYPE, INITIAL_CHAT_BUTTON_TEXT, ONBOARDING_MESSAGES, ONBOARDING_RESPONSE_TYPE } =
    FIELDS_MAPPER;

  const cleanedData = cloneDeep(workingState);

  const chatButtonType = get(cleanedData, INITIAL_CHAT_BUTTON_ICON_TYPE.path);

  if (chatButtonType === ICON) {
    set(cleanedData, INITIAL_CHAT_BUTTON_TEXT.path, INITIAL_CHAT_BUTTON_TEXT.defaultValue);
  }

  if (get(cleanedData, ONBOARDING_RESPONSE_TYPE.path) === 'TEXT') {
    set(cleanedData, ONBOARDING_MESSAGES.path, []);
  }

  const onboardingMessages = formatOnboardingMessages(get(cleanedData, ONBOARDING_MESSAGES.path));

  set(cleanedData, ONBOARDING_MESSAGES.path, onboardingMessages);

  return cleanedData;
};

const formatOnboardingMessages = onboardingMessages => {
  return onboardingMessages.map(message => {
    const newMessage = message;
    if (message.subType === 'QUICK_REPLY_REQUEST') {
      newMessage.subTypeContent.options = message.subTypeContent.options.map(option => {
        option.id = option.buttonId;
        return option;
      });
    }
    return newMessage;
  });
};

const mapOfTranslations = [['<<USERNAME>>', '<CUSTOMERNAME>']];

export const translate = <T>(obj: T, options: { reverse: boolean } = { reverse: false }) =>
  translationFunction(obj, options, mapOfTranslations);
